let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d8Ai7")).then(() => parcelRequire('gSqCA'));